<div class="status-park">
    <div class="chart-container" #chartTarget style="width: 100%"></div>
</div>
<div *ngIf="showTable && componentName === 'status-park'">
    <app-status-park-table
        [dataTable]="totalSeriesByStatus"
    ></app-status-park-table>
</div>
